export const getAllOrders = () => `storehouse/orders/?`